import * as React from 'react';

function SvgTransfer(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={38.737} height={38.699} {...props}>
      <defs>
        <style>{'.transfer_svg__prefix__cls-1{fill:#7689b4}'}</style>
      </defs>
      <g id="transfer_svg__prefix__transfer" transform="translate(-202 202)">
        <path
          id="transfer_svg__prefix__Path_5643"
          d="M240.737-171.026l-9.752-6.143a11.026 11.026 0 001.453-5.478 11.015 11.015 0 00-1.12-4.857v-3.533a7.617 7.617 0 00-7.611-7.611h-9.45V-202L202-194.275l9.752 6.143a11.026 11.026 0 00-1.453 5.478 11.015 11.015 0 001.12 4.857v3.533a7.617 7.617 0 007.611 7.611h9.45v3.352zm-28.167-11.629a8.812 8.812 0 018.8-8.8 8.812 8.812 0 018.8 8.8 8.812 8.812 0 01-8.8 8.8 8.807 8.807 0 01-8.801-8.799zm-.583-8.012l-5.727-3.609 5.727-3.609v1.506H223.7a5.35 5.35 0 015.341 5.341v.416a11.015 11.015 0 00-7.672-3.1 10.976 10.976 0 00-5.636 1.551h-3.745zm1.71 15.986a11.015 11.015 0 007.672 3.1 10.976 10.976 0 005.631-1.548h3.745v-1.506l5.727 3.609-5.727 3.609v-1.506H219.03a5.35 5.35 0 01-5.341-5.341v-.416z"
          className="transfer_svg__prefix__cls-1"
          data-name="Path 5643"
        />
        <g
          id="transfer_svg__prefix__Group_2655"
          data-name="Group 2655"
          transform="translate(217.184 -188.518)"
        >
          <g id="transfer_svg__prefix__Group_2654" data-name="Group 2654">
            <path
              id="transfer_svg__prefix__Path_5644"
              d="M410.773-22.241h-2.444a3.061 3.061 0 01.477 1.112h1.967v1.559h-1.937a3.355 3.355 0 01-1.236 2.07 4.6 4.6 0 01-2.179.87c1.256 1.354 2.6 2.966 3.866 4.524l.454.552h-2.557l-.1-.121c-1.377-1.664-2.656-3.178-4.282-4.918l-.091-.1v-1.566h1.294c1.43 0 2.345-.469 2.618-1.316H402.7v-1.559h3.783c-.333-.567-1.074-.847-2.194-.847H402.7V-23.8h8.065v1.559z"
              className="transfer_svg__prefix__cls-1"
              data-name="Path 5644"
              transform="translate(-402.7 23.8)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgTransfer;
